<app-header></app-header>
<div style="background: url(./media/small-industry.jpg);background-repeat: repeat;background-size: auto;">
<!--<mat-toolbar class="mat-elevation-z4">
  <h1 class="text-center">Invitation for Expression of Interest (EoI)</h1>
</mat-toolbar>-->
<header>
  <h1>Invitation for Expression of Interest (EoI)</h1>
  <p>Subsidy on Lease Rental Costs for Udyam Registered MSMEs in Maharashtra</p>
</header>

<!-- <header>
  <h1>Invitation for Expression of Interest (EoI)</h1>
  <p>Subsidy on Lease Rental Costs for Udyam Registered MSMEs in Maharashtra</p>
</header> -->

<header class="scheme-notice">
  <div class="notice-box">




    <!-- <div class="notice-text">





      <p class="text-danger" style="font-size: 20px; font-weight: bold;">
       The Flatted Galas Rent Subsidy Scheme is currently paused pending a final decision from the Ministry of MSME on the implementation modalities.
        A decision is expected shortly. In the event of a favourable progression, the deadline of 
        <strong>31 March 2026</strong> may be extended to ensure accommodation of all willing applicants.
      </p>

      <p class="contact text-danger" style="font-size: 20px; font-weight: bold;">
        For further queries, please write to 
        <a href="mailto:hrmssidc@gmail.com">hrmssidc&#64;gmail.com</a> 
        or 
        <a href="mailto:mssidciitf@gmail.com">mssidciitf&#64;gmail.com</a>.
      </p>
    </div> -->
  </div>
</header>
<main>
  <mat-card class="main-card px-4" style="margin-top:25px;">
    <!--<h2 class="mat-headline">Subsidy on Lease Rental Costs for Udyam Registered MSMEs in Maharashtra</h2>-->
    <p class="my-4 para-fnt">
      The <strong>Maharashtra Small Scale Industries Development Corporation Limited (MSSIDC Ltd.)</strong> invites
      <strong>Expressions of Interest (EoI) for flatted gala subsidy </strong> from <strong>Micro, Small, and Medium Enterprises (MSMEs)</strong> possessing valid
      <strong>Udyam Registration</strong> with the Ministry of MSME, Government of India.
    </p>

    <mat-card class="highlight-box mat-elevation-z1">
      <ul>
        <!-- <li><strong>Benefit:</strong> 50% reimbursement-based subsidy on lease rental costs</li>
        <li><strong>Maximum Reimbursement:</strong> ₹40,000 per month per MSME</li> -->
        <li><strong>Eligibility:</strong> MSMEs with valid Udyam Registration</li>
        <li><strong>Purpose:</strong> Rent subsidy for built-up space</li>
      </ul>
    </mat-card>

    <!--<h3 class="deadline">Offer of Reimbursement Based Subsidy</h3>-->

    <!-- <mat-expansion-panel (opened)="isExpanded = true" (closed)="isExpanded = false">
      <mat-expansion-panel-header class="btn btn-warning w-35">
        <mat-panel-title class="btn btn-warning text-white fontsize">
          {{ isExpanded ? 'Offer of Reimbursement Based Subsidy' : 'Offer of Reimbursement Based Subsidy' }}
        </mat-panel-title>
      </mat-expansion-panel-header>

      <p class="para-fnt"><strong>Offer of Reimbursement based Subsidy on Lease Rental Costs to MSMEs operating in Industrial Spaces under the RAMP Programme by MSSIDC:</strong></p>
      <ol>
        <li>This scheme is designed to extend benefits to 300 MSMEs</li>
        <li>Rental subsidy of 50% (up to ₹40,000/month) available up to 31.03.2027</li>
        <li>Selection via lucky draw among eligible applicants</li>
        <li>
          <strong>Eligibility Criteria:</strong>
          <ul>
            <li>Valid Udyam Registration (Maharashtra)</li>
            <li>Valid rent agreement with lessor</li>
            <li>Classified under CPCB’s White or Green Category</li>
            <li>Minimum 5 full-time employees</li>
   
            <li>Must be in existence for not more than 5 years as on date of submission</li>
            <li>Preference to manufacturing units</li>
            <li>
              Reservation Policy:
              <ul>
                <li>SC: 7%</li>
                <li>ST: 2.5%</li>
                <li>Women: 25%</li>
              </ul>
            </li>
          </ul>
        </li>
      </ol>
    </mat-expansion-panel> -->

    
    <mat-expansion-panel (opened)="isExpanded = true" (closed)="isExpanded = false">
      <mat-expansion-panel-header class="btn btn-warning w-35">
        <mat-panel-title class="btn btn-warning text-white fontsize">
          {{ isExpanded ? 'Offer of Reimbursement Based Subsidy' : 'Offer of Reimbursement Based Subsidy' }}
        </mat-panel-title>
      </mat-expansion-panel-header>

      <p class="para-fnt"><strong>Offer of Reimbursement based Subsidy on Lease Rental Costs to MSMEs operating in Industrial Spaces under the RAMP Programme by MSSIDC:</strong></p>
      <ol>
         <li>
          <strong>Eligibility Criteria:</strong>
          <ul>
            <li>Valid Udyam Registration (Maharashtra)</li>
            <li>Valid rent agreement with lessor</li>
            <li>Classified under CPCB’s White or Green Category</li>
            <li>Minimum 5 full-time employees</li>
            <!--<li>Operational for not more than 10 years</li>-->
            <li>Must be in existence for not more than 5 years as on date of submission</li>
            <li>Preference to manufacturing units</li>
            <li>
              Reservation Policy:
              <ul>
                <li>SC: 7%</li>
                <li>ST: 2.5%</li>
                <li>Women: 25%</li>
              </ul>
            </li>
          </ul>
        </li>
        <!-- <li>Rental subsidy of 50% (up to ₹40,000/month) available up to 31.03.2027</li> -->
        <li>Selection via lucky draw among eligible applicants</li>

      </ol>
    </mat-expansion-panel>

    

    <h2>Application Process</h2>
    <p><a class="btn btn-primary btn-sm text-white" href="assets/Images/EOI_Details.pdf" download="EOI_Details.pdf"><i class="bi bi-download"></i> EOI Document</a> &nbsp;
       <a class="btn btn-primary btn-sm text-white" href="assets/Images/Corrigendum_EOI_Details.pdf" download="Corrigendum_EOI_Details.pdf"><i class="bi bi-download"></i> Corrigendum for EOI</a> This EOI document outlines eligibility criteria, submission requirements, and other relevant terms. Interested and eligible MSMEs are encouraged to apply before the last date.</p>

    <div class="action-buttons mb-3">
      <button (click)="navigate()" class="btn btn-success me-3">
        <i class="bi bi-clipboard-check"></i> Apply Now
      </button>
     
    </div>
    <p>
      For full details on eligibility, application format, and terms of allotment, please refer to the EOI Document.
    </p>
    <p class="deadline">Last Date for Submission:  <span style="color: red;">31-July-2026 on or before: 05:00 P.M</span></p>

    <mat-card class="contact-box mat-elevation-z1">
      <strong>For queries and clarifications:</strong>
      MSSIDC, 2nd Floor, Krupanidhi Building,<br>
      9, Walchand Hirachand Marg, Ballard Estate, Fort, Mumbai - 400001<br>
      <strong>Email:</strong> <a href="mailto:hrmssidc&#64;gmail.com">hrmssidc&#64;gmail.com</a>
      <!-- <a href="mailto:mssidciitf&#64;gmail.com">mssidciitf&#64;gmail.com</a><br> -->
      <strong>Working Hours:</strong> 10:00 AM to 6:00 PM
    </mat-card>

    <mat-card class="note-box mat-elevation-z1">
      <strong>Note:</strong>
      <ul>
        <li>MSSIDC reserves the right to cancel this invitation for EoI</li>
        <li>May re-invite EoIs with/without amendments</li>
        <li>May update terms/details without any obligation</li>
      </ul>

    </mat-card>

    
  </mat-card><br />
</main>

 </div>
<app-footer></app-footer>
